module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "otherbooks",
    attrs: {
      "id": "adc"
    }
  }, [_c('h1', {
    staticClass: "otherbooks"
  }, [_vm._v("ALSO BY MICHAEL FLYNN")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("In the Country of the Blind")]), _c('a', {
    attrs: {
      "id": "fn1a"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#fn1"
    }
  }, [_vm._v("*")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("The Nanotech Chronicles")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Fallen Angels")]), _vm._v(" (with Larry Niven and Jerry Pournelle)"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Firestar*")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("The Forest of Time and Other Stories*")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Lodestar*")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Rogue Star*")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Falling Stars*")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("The Wreck of the River of Stars*")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "fn1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#fn1a"
    }
  }, [_vm._v("*")]), _vm._v(" denotes a Tor book")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab1fb180","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780765340351_epub_adc_r1.vue
// module id = 60
// module chunks = 0